import type { FC } from 'react';

import { Flex, Alert, AlertDescription, Button } from '@vimeo/bokeh';
import { SyncRefreshFilled } from '@vimeo/bokeh-icons';
import { translate } from '@vimeo/i18n-runtime';

type Props = {
  onRetry: () => void;
  isLoading?: boolean;
};
export const TryAgainAlert: FC<Props> = ({ onRetry, isLoading }) => {
  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      mt="sm"
      gap="md"
      flexDirection="column"
    >
      <Alert status="error">
        <AlertDescription>{translate('Unable to load content')}</AlertDescription>
      </Alert>
      <Button
        isLoading={isLoading}
        onClick={() => {
          onRetry();
        }}
        size="sm"
        variant="primary"
        width="100%"
        leftIcon={<SyncRefreshFilled />}
      >
        {translate('Try again')}
      </Button>
    </Flex>
  );
};
